import { Slide } from "react-toastify";

export const TOAST_TYPES = {
  success: "success",
  info: "info",
  warning: "warning",
  error: "error",
  defaultType: "default",
};

// for default configs refer https://fkhadra.github.io/react-toastify/api/toast-container
// overrided default configs:-
export const DEFAULT_CONFIG = {
  position: "top-right",
  newestOnTop: true,
  theme: "colored",
  transition: Slide,
  closeOnClick: false,
  pauseOnHover: false,
  icon: false,
};

export const PERSISTING_FLASH_CONFIG = { autoClose: false };

export const DEFAULT_SUCCESS_TITLE = "Success!";

export const DEFAULT_ERROR_TITLE = "Something went wrong.";

export const DEFAULT_MESSAGE =
  "There was a problem with the request. Please try again after some time.";

export const STRIPE_SETUP_ERROR_TOAST_ID = "stripe-setup-error";

export const PAYMENT_ERROR_CONFIG = {
  autohide: false,
  toastId: STRIPE_SETUP_ERROR_TOAST_ID,
};
